function debounce(func, wait) {
    let timeout;
    return function () {
        const context = this, args = arguments;
        const later = function () {
            timeout = null;
            func.apply(context, args);
        };
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
    };
}

function adjustAnchorHolder(anchorHolder) {
    const parentElement = anchorHolder.parentElement;
    const parentHeight = parentElement.offsetHeight;
    const screenHeight = window.innerHeight;

    if (parentHeight < screenHeight) {
        const translateYValue = -(screenHeight - parentHeight) / 2;
        anchorHolder.style.transform = `translateY(${translateYValue < -50 ? translateYValue : -50}px)`;
    } else {
        anchorHolder.style.transform = null;
    }
}

function setupAnchorHolders() {
    const anchorHolders = document.querySelectorAll('.cs-anchorholder');

    anchorHolders.forEach((anchorHolder) => {
        adjustAnchorHolder(anchorHolder);

        const debouncedAdjust = debounce(() => adjustAnchorHolder(anchorHolder), 100);

        window.addEventListener('resize', debouncedAdjust);

        const parentElement = anchorHolder.parentElement;
        parentElement.addEventListener('resize', debouncedAdjust);
    });
}

export { setupAnchorHolders };